var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSuccessOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z",
    fill: "#FEF0EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70669 11.5735C8.59371 11.4533 8.43786 11.3826 8.27303 11.3767C8.1082 11.3708 7.94772 11.4303 7.82648 11.5422C7.70525 11.6541 7.63307 11.8093 7.62564 11.9741C7.6182 12.1389 7.67612 12.3 7.78679 12.4224L10.0471 14.8756C10.3832 15.2049 10.8838 15.2049 11.1948 14.8944L11.4226 14.6697C12.2452 13.8604 13.0669 13.0502 13.8876 12.2389L13.9126 12.2139C14.6796 11.4577 15.4427 10.6975 16.2017 9.93338C16.3152 9.81456 16.3774 9.65589 16.3749 9.4916C16.3725 9.32732 16.3055 9.17059 16.1886 9.05523C16.0716 8.93988 15.914 8.87514 15.7498 8.875C15.5855 8.87486 15.4278 8.93932 15.3106 9.05447C14.5551 9.81465 13.7958 10.5711 13.0328 11.3237L13.0077 11.3488C12.2213 12.1264 11.4338 12.9031 10.6454 13.6787L8.70669 11.5735Z",
    fill: "#E8430F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccessOrange);
export default __webpack_public_path__ + "static/media/ic_success_orange.24dbe6a958c601741601905ad25d0583.svg";
export { ForwardRef as ReactComponent };